module.exports = __webpack_public_path__ + "static/media/darkgalaxies.464dc48b.webp";